import { get } from 'lodash';
import { BusinessUnit, EVENT_TYPES } from '../../constants';
import { getPageFromPathname } from '../../middleware/getPageFromPathname';
import { AnalyticsTypes, GA } from '../../middleware/google-analytics';
import { INITIAL_BOOKING_ROOT_KEY } from '../constants';
import { GA_PAGES } from '../middleware/booking';
import { logEvent } from '../utils';

export const MadeItToPinEvent = 'MadeItToPin';
export const PageLoggingEvents = {
    [GA_PAGES.APPOINTMENT_DETAILS]: 'MadeItToReview',
    [GA_PAGES.APPOINTMENT_INFO]: 'MadeItToStart',
    [GA_PAGES.BOOKING_COMPLETE]: 'MadeItToComplete',
    [GA_PAGES.CREATE_ACCOUNT]: 'MadeItToExpressCheckout',
    [GA_PAGES.REVIEW_AND_BOOK_PAGE]: 'MadeItToReviewAndBook',
    [GA_PAGES.PATIENT_INFO]: 'MadeItToPatientInfo',
    [GA_PAGES.PHONE_VERIFICATION]: 'MadeItToPhone',
    [GA_PAGES.REGISTER]: 'MadeItToExpressCheckout',
    [GA_PAGES.SELECT_PATIENT]: 'MadeItToPatientSelect',
    [GA_PAGES.SIGN_IN]: 'MadeItToSignIn',
    [GA_PAGES.SIGN_UP]: 'MadeItToSignUp',
    [GA_PAGES.CREATE_USERNAME]: 'MadeItToCreateUsername',
    [GA_PAGES.CREATE_PASSWORD]: 'MadeItToCreatePassword',
};

export const eventsLogger = (store) => (next) => (action) => {
    const result = next(action);

    if (typeof window !== 'undefined' && action.meta) {
        if (action.meta.logs) {
            const state = store.getState();
            const { pathname } = state.routing.locationBeforeTransitions;
            return getPageFromPathname(pathname).then(({ pageName }) => {
                if (pageName) {
                    const eventData = get(action.meta.logs, 'data', {});
                    eventData.Page = pageName;
                    const event = Object.assign(action.meta.logs, {
                        data: eventData,
                    });
                    logEvent({
                        event,
                        businessUnit: BusinessUnit.LOGS,
                    });
                }
            });
        } else if (action.meta.analytics) {
            const state = store.getState();
            const pathname =
                get(state, 'routing.locationBeforeTransitions.pathname') ||
                window.location.pathname;

            if (pathname) {
                const bookingId = getBookingId(pathname);
                return getPageFromPathname(pathname).then(
                    ({ pageName, category }) => {
                        if (pageName) {
                            let analyticsArray = [action.meta.analytics];
                            if (Array.isArray(action.meta.analytics)) {
                                analyticsArray = action.meta.analytics;
                            }

                            for (let i = 0; i < analyticsArray.length; i++) {
                                const analytics = analyticsArray[i];
                                const eventData = get(analytics, 'data', {});
                                eventData.Page = pageName;
                                if (
                                    analytics.type ===
                                    AnalyticsTypes.ChangePageView
                                ) {
                                    setWhiteLabels(state, eventData);
                                }

                                action.meta.analytics = analytics;
                                const event = Object.assign(
                                    action.meta.analytics,
                                    { data: eventData }
                                );
                                event.category = event.category || category;
                                processAction(event, bookingId);
                            }
                        }
                    }
                );
            } else {
                return result;
            }
        } else {
            return result;
        }
    } else {
        return result;
    }
};

const setWhiteLabels = (state, eventData) => {
    const whiteLabelName = get(
        state[INITIAL_BOOKING_ROOT_KEY],
        'whiteLabelName',
        ''
    );
    if (whiteLabelName) {
        eventData.IsWhiteLabel = true;
        eventData.WhiteLabelName = whiteLabelName;
    } else {
        eventData.IsWhiteLabel = false;
    }
};

function getBookingId(pathname) {
    const separated = pathname.split('/');
    if (separated.length !== 4) {
        return '';
    } else {
        return separated[3];
    }
}

function logTrackedEvent(action, bookingId) {
    if (!action.category || !action.action) {
        return;
    }

    const event = {
        type: EVENT_TYPES.Action,
        data: {
            ...action.data,
            Name: `[${action.category}] ${action.action}`,
            Action: action.action,
            Category: action.category,
            EventDetails: action.eventDetails,
        },
    };

    logEvent({
        event,
        bookingId,
        businessUnit: BusinessUnit.PATIENT_WEB_APP,
    });
}

function logPageChangeEvent(action, bookingId) {
    if (!action.page) {
        return;
    }
    if (PageLoggingEvents[action.page]) {
        const event = {
            type: EVENT_TYPES.Pageview,
            bookingEventLoggerType: PageLoggingEvents[action.page],
            data: {
                ...action.data,
                Name: PageLoggingEvents[action.page],
                Path: action.page,
                CurrentUrl: window.location.href,
                PreviousUrl: document.referrer,
                PracticeId: action.practiceId,
            },
        };
        logEvent({
            event,
            bookingId,
            businessUnit: BusinessUnit.PATIENT_WEB_APP,
        });
    }
}

function logSetDimensionEvent(action, bookingId) {
    const event = {
        type: EVENT_TYPES.SetCustomDimension,
        data: {
            ...action.data,
            Name: GA.DimensionValues[action.index],
            Value: action.value,
        },
    };
    logEvent({
        event,
        bookingId,
        businessUnit: BusinessUnit.PATIENT_WEB_APP,
    });
}

function processAction(analyticsAction, bookingId) {
    switch (analyticsAction.type) {
        case AnalyticsTypes.TrackEvent:
            logTrackedEvent(analyticsAction, bookingId);
            break;
        case AnalyticsTypes.ChangePageView:
            logPageChangeEvent(analyticsAction, bookingId);
            break;
        case AnalyticsTypes.SetDimension:
            logSetDimensionEvent(analyticsAction, bookingId);
            break;
        // no default
    }
}
